/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareForbid2 = createReactComponent("square-forbid-2", "IconSquareForbid2", [
  [
    "path",
    {
      d: "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M9 15l6 -6", key: "svg-1" }]
]);

export { IconSquareForbid2 as default };
//# sourceMappingURL=IconSquareForbid2.js.map
